<div class="generic-tab-selection-label" *ngIf="tabIntentLabel"> {{tabIntentLabel | translate }}</div>
<gen-tabs-header *ngIf="tabs.length > 0 && tabConfiguration" [tabs]="tabs" [currentTab]="currentTabTitle"
                 (tabChange)="onTabChange($event)"
                 [ngClass]="stylemodifier">
</gen-tabs-header>

<section *ngIf="loading" class="generic-loading-icon-wrapper">
  <gen-overlay-loader [showOverlay]="false"></gen-overlay-loader>
</section>
<section class="generic-tab-selection-wrapper">
  <section class="no-data-message" *ngIf="noData">
    {{noDataMessage}}
  </section>
  <section *ngIf="loading === false && categoryItemtList" class="generic-tab-selection"
           [ngClass]="{'generic-tab-selection-full': !showRecommendedList?.formId,
           'multi-organ-hide-edit': hideDecisions,
           'generic-tab-selection-half': showRecommendedList?.formId}"
           [ngStyle]= "{'max-height': selectionPanelHeight}">
    <div *ngFor="let catItem of categoryItemtList | sortBy: sortByIndex : sortByItem">
      <div class="item-tab-wrapper">
        <gen-button class="{{catItem.itemId}} item-tab"
                    [ngClass]="{'item-selected': itemsCount[catItem.itemId] > 0}"
                    (click)="openSubItem(catItem, itemsCount[catItem.itemId])"
                    [text]="catItem.itemName"
                    [disabled]="disableFirstLevel === false ? disableFirstLevel : !permitItemSelectionWrite">
        </gen-button>
        <div class="selected-item-count"
             *ngIf="itemsCount[catItem.itemId] > 0">
          {{itemsCount[catItem.itemId]}}
        </div>
      </div>
    </div>
  </section>


  <div *ngIf="loading === false">
    <recommended-list
            [showRecommendedList]="showRecommendedList"
            [expandCollapseRequired]="expandCollapseRequired"
            [expandRecommendedList]="expandRecommendedList"
            [totalSelectedItemList]="totalSelectedItemList"
            [noData]="noData"
            [permitItemSelectionWrite]="permitItemSelectionWrite"
            [recommendedListItem]="recommendedListItem"
            (emitRecommendedItems)="emitRecommendedItems($event)"
    >
    </recommended-list>
  </div>


  <generic-sub-selection *ngIf="subSelectionPanelClose"
                         [subItems]="subItems"
                         [totalSelectedItemList]="selectedSubItemList"
                         [totalSelectedItemsCount]="totalSelectedItemList?.length+1"
                         [restrictItemsCount]="restrictItems.maxCount"
                         [restrictionMessage]="restrictItems.message"
                         (emitSelectedItems)="emitSelectedItems($event)"
                         [subSelectionPanel]="subSelectionPanelClose"
                         (emitSubSelectionPanelClose)="backwardPanel(event)"
                         [permitItemSelectionWrite]="permitItemSelectionWrite"
                         [selectionType]="selectionType"
                         [sortByItem]="sortByItem"
                         [pncStatus]="pncStatus"
  ></generic-sub-selection>

</section>


